﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";
/*import * as $ from "jquery";*/
import './jquery';
import "jquery-mask-plugin";
import "jquery-validation"
import "jquery-validation-unobtrusive";
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import { SignatureWidget } from "./signature";

export class NoLoginSignWidget {
    private element: HTMLElement;
    private service: Service;
    private statusBarWidget: StatusBarWidget;
    private debug: boolean = true;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;
        this.init();
    }

    init() {
        let th = this;             
        $('.confirm-options').off("click");
        $('.confirm-options').on("click", (ev: Event) => th.submitSignOptions(ev));
        $('form').on("submit", (ev: Event) => th._showLoader());
    }
    async submitSignOptions(ev: Event) {
        ev.preventDefault();
        this._debugging("submitSignOptions");
        let th = this;
        let form = $("#options-form");
        //(form.find("#continueWith") as JQuery<HTMLInputElement>).removeAttr("disabled");
        //(form.find("#zastopstvo") as JQuery<HTMLInputElement>).removeAttr("disabled");
        th._showLoader();

        var options = form.serializeArray();
        this._debugging(options);
        let continueWith = "";
        let pravnaOseba = "";
        let id = "";
        options.forEach(function (e, i) {
            if (e.name == 'zastopstvo') pravnaOseba = e.value;
            if (e.name == 'continueWith') continueWith = e.value;
            if (e.name == 'id') id = e.value;
        })
        continueWith = $(ev.currentTarget).attr("data-value");

        let data = JSON.stringify({ id: id, callBack: window.location.href, ContinueWith: continueWith, PravnaOseba: pravnaOseba });
        let url = "sign";
        
        this._debugging("posting: " + data.toString() + " to: " + url)
        var signUrl = await this.service.PostJson(data, url, this.statusBarWidget);
        this.onPostSignDone(signUrl);
    }

    onPostSignDone(PodpisUrl: any) {
        let self = this;
        this._debugging("post done: " + PodpisUrl.toString());

        location.href = PodpisUrl;
        window.addEventListener("message", function (event) {
            if (event.origin === PodpisUrl) {
                alert("Response from Rekono: " + event.data);
                self._hideLoader();
            }
        });

    }

    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
}
